import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpModule } from '@angular/http';
import { PaymentModule } from '@flysas/payment';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpInterceptorModule } from 'ng-http-interceptor';
import { TranslateModule, TranslateLoader, MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { CookieModule } from 'ngx-cookie';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeviceDetectorService  } from 'ngx-device-detector';

import { HttpserviceModule, HttputilInterceptor, HttpClientService } from '@flysas/httputil';
import { Observable } from 'rxjs/Observable';

import { HoursMinutesPipe } from './pipes/hours-minutes.pipe';
import { FormatPricePipe } from './pipes/format-price.pipe';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LandingComponent } from './components/landing/landing.component';
import {WiFiAccessPrices} from './components/wifi-access-prices/wifi-access-prices';
import { SwitchComponent } from './components/switch/switch.component';
import { FeaturesComponent } from './components/features/features.component';
import { CustomerComponent } from './components/customer/customer.component';
import { ErrorComponent } from './components/error/error.component';
import { PaymentSelectionComponent } from './components/eb/paymentSelection.component';
import { PaymentConfirmationComponent } from './components/payment/payConfirm/paymentConfirmation.component';
import { environment } from '../environments/environment';
import { APP_TRANSLATE } from './app.translation.en';

import { AppService } from './app.service';
import { UtilService } from './util.service';
import { AppConfigService } from './services/app.config.service';
import { ActivateService } from './services/activate.service';
import {TravelersService} from './components/travelers/travelers.service';
import { LandingService } from './components/landing/landing.service';
import { HttpService } from './services/http.service';
import { ErrorService } from './components/error/error.service';
import { SwitchService } from './components/switch/switch.service';
import { BuywifiService } from './services/buywifi.service';
import { DatalayerService } from './services/datalayer.service';
import { AccessibilityService } from './services/accessibility.service';
import { NavtabsComponent } from './components/navtabs/navtabs.component';
import { SkiplinkComponent } from './components/skiplink/skiplink.component';
import { ReadMoreComponent } from './components/landing/read-more/read-more.component';
import { LoaderComponent } from './components/loader/loader.component';
import { TravelersComponent } from './components/travelers/travelers.component';
import { PnrLoginComponent } from './components/travelers/pnr-login/pnr-login.component';
import { DisabledLoginFormComponent } from './components/travelers/disabled-login-form/disabled-login-form.component';
import { EbLoginComponent } from './components/travelers/eb-login/eb-login.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { ProductsComponent } from './components/products/products.component';
import { CartComponent } from './components/products/cart/cart.component';
import { PaymentComponent } from './components/payment/payment.component';
import { PayComponent } from './components/payment/pay/pay.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { TravellersService } from './components/travelers/travellers.service';
import { BreadcrumbsService } from './components/breadcrumbs/breadcrumbs.service';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { ConfirmationService } from './components/confirmation/confirmation.service';
import { CartService } from './components/products/cart/cart.service';
import { PaymentService } from './components/payment/payment.service';
import { CheckoutReviewService } from './components/payment/services/checkout-review.service';
import { PaymentConfirmationService } from './components/payment/payConfirm/paymentConfirmation.service';
import { FooterComponent } from './components/footer/footer.component';
import {VoucherComponent} from './components/voucher/voucher.component';
import { VoucherLoginComponent} from './components/travelers/pnr-login/voucher-login.component';
import { CrewVoucherComponent } from './components/crew-voucher/crew-voucher.component';
import { TopHeaderComponent } from './components/top-header/top-header.component';
import { BottomFooterComponent } from './components/bottom-footer/bottom-footer.component';
import { AuthModule } from '@auth0/auth0-angular';
import { ONBOARD_CONSTANTS } from './app.constants';

export class CustomTranslateLoader implements TranslateLoader  {
  public contentHeader:any = new HttpHeaders()
  .append('noToken', 'true');
  
  constructor(private http: HttpClient) {}
  getTranslation(lang: string): Observable<any> {
      const jsonStr =  '.json';
      const apiAddress = environment.translationFileBaseUrl + lang + jsonStr;
      return this.http.get(apiAddress, { headers: this.contentHeader })
        .pipe(
          //catchError(_ => this.http.get(environment.translationFileBaseUrl + `en.json`))
        );
  }
}
export const appInitializerFn = (appConfigService: AppConfigService) => {
  return () => {
    return appConfigService.loadAppConfig();
  };
}

export class AppMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return APP_TRANSLATE[params.key];
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    WiFiAccessPrices,
    SwitchComponent,
    FeaturesComponent,
    CustomerComponent,
    ErrorComponent,
    NavtabsComponent,
    HoursMinutesPipe,
    FormatPricePipe,
    SkiplinkComponent,
    ReadMoreComponent,
    LoaderComponent,
    TravelersComponent,
    PnrLoginComponent,
    EbLoginComponent,
    TermsAndConditionsComponent,
    ProductsComponent,
    CartComponent,
    PaymentComponent,
    PayComponent,
    ConfirmationComponent,
    BreadcrumbsComponent,
    DisabledLoginFormComponent,
    FooterComponent,
    PaymentSelectionComponent,
    PaymentConfirmationComponent,
    VoucherComponent,
    VoucherLoginComponent,
    CrewVoucherComponent,
    TopHeaderComponent,
    BottomFooterComponent

  ],
  exports: [
    TranslateModule
  ],
  imports: [
    AuthModule.forRoot({
      domain: window.location.hostname.includes('localhost') || window.location.hostname.includes('test') ? ONBOARD_CONSTANTS.AuthDomainTest : ONBOARD_CONSTANTS.AuthDomainProd, // Add your Auth0 domain from environment variables
      clientId: window.location.hostname.includes('localhost') || window.location.hostname.includes('test') ? ONBOARD_CONSTANTS.ClientIdTest : ONBOARD_CONSTANTS.ClientIdProd, // Add your Auth0 client ID from environment variables
      //authorizationParams: {
        redirect_uri: window.location.hostname.includes('localhost') || window.location.hostname.includes('test') ? ONBOARD_CONSTANTS.callbackURLTest : ONBOARD_CONSTANTS.callbackURLProd,
        audience: 'flysas-api'
      //}
    }),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PaymentModule,
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    HttpserviceModule,
    FormsModule,
    ReactiveFormsModule,
    HttpInterceptorModule,
    CookieModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: (CustomTranslateLoader),
        deps: [HttpClient]
      },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: AppMissingTranslationHandler },
      useDefaultLang: false
    }),
  ],
  providers: [
    AppService,
    UtilService,
    DeviceDetectorService,
    // { provide: HTTP_INTERCEPTORS, useClass: HttputilInterceptor, multi: true },
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    LandingService,
    HttpService,
    TravelersService,
    ErrorService,
    SwitchService,
    AccessibilityService,
    BuywifiService,
    DatalayerService,
    HttpClientService,
    TravellersService,
    BreadcrumbsService,
    ConfirmationService,
    PaymentService,
    CheckoutReviewService,
    CartService,
    DatalayerService,
    ActivateService, 
    PaymentConfirmationService,
    VoucherComponent,
  ],
  bootstrap: [AppComponent, ErrorComponent, NavtabsComponent, TopHeaderComponent, BottomFooterComponent, SkiplinkComponent]
})
export class AppModule { }
